import { BillingTransferRequestStatus } from "@common/constants/domains/billing/billingTransferRequest";
import { z } from "zod";

export const orgBillingTransferCandidateSchema = z.object({
    userUuid: z.string().uuid(),
    name: z.string(),
    email: z.string().nullable(),
});

export type OrgBillingTransferCandidate = z.infer<
    typeof orgBillingTransferCandidateSchema
>;

export const orgBillingTransferCandidatesSchema = z.object({
    isFixedRecipient: z.boolean(),
    candidates: z.array(orgBillingTransferCandidateSchema),
});

export type OrgBillingTransferCandidates = z.infer<
    typeof orgBillingTransferCandidatesSchema
>;

export const orgBillingTransferRequestSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    clientId: z.string(),
    issuedByUserId: z.number(),
    newPrimaryAdminUserUuid: z.string().uuid().nullable(),
    status: z.nativeEnum(BillingTransferRequestStatus),
});

export type OrgBillingTransferRequest = z.infer<
    typeof orgBillingTransferRequestSchema
>;

export const orgBillingTransferCheckoutSchema = z.object({
    intentId: z.string(),
    clientSecret: z.string(),
});

export type OrgBillingTransferCheckout = z.infer<
    typeof orgBillingTransferCheckoutSchema
>;

export const pendingOrgBillingTransferRequestSchema = z.object({
    id: z.string().uuid(),
    organizationName: z.string(),
    issuedByUserName: z.string(),
});

export type PendingOrgBillingTransferRequest = z.infer<
    typeof pendingOrgBillingTransferRequestSchema
>;

export const pendingOrgBillingTransferRequestResponseSchema = z.object({
    request: pendingOrgBillingTransferRequestSchema.nullable(),
});
